<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5">
            <v-row dense>
              <v-col cols="12">
                <strong>Print Barcode Relasi</strong>
              </v-col>
            </v-row>
            <hr />
            <v-row class="mt-4">
              <!-- <v-col cols="3" md="3">
                <v-autocomplete
                  v-model="branch"
                  :items="branchList"
                  item-text="BRANCH_CODE"
                  :disabled="!isSuperUser"
                  label="Branch"
                  color="red darken-1"
                  outlined
                  dense
                />
              </v-col> -->
              <v-col cols="3" md="3">
                <v-autocomplete
                  v-model="position"
                  :items="positionList"
                  item-text="POSITION_DESC"
                  label="Position"
                  color="red darken-1"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="3" md="3">
                <v-btn
                  @click="getRelasiPrintList"
                  color="error"
                  :disabled="dtLoading"
                >
                  Load List
                </v-btn>
              </v-col>
            </v-row>

            <!-- Relasi Table -->
            <v-row>
              <v-col cols="12">
                <v-card class="pa-3" outlined>
                  <!-- Table Head -->
                  <v-card-title>
                    <v-spacer />
                    <v-text-field
                      color="red darken-1"
                      v-model="searchRole"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    />
                  </v-card-title>

                  <!-- Table Content -->
                  <v-data-table
                    :headers="dtHeaders"
                    :items="dtItems"
                    :search="searchRole"
                    :loading="dtLoading"
                    loading-text="Fetching Data..."
                    dense
                  >
                    <!-- Custom "Date Print" formatting -->
                    <template v-slot:item.LAST_UPDATE_PRINT="{ item }">
                      <span v-show="item.LAST_UPDATE_PRINT">
                        {{
                          moment(item.LAST_UPDATE_PRINT).format(
                            "YYYY-MM-DD HH:mm:ss"
                          )
                        }}
                      </span>
                    </template>

                    <!-- Reprint button -->
                    <template v-slot:item.ShouldReprint="{ item }">
                      <span v-show="item.ShouldReprint">
                        <v-btn
                          small
                          outlined
                          color="error"
                          class="reprint-button"
                          @click="printQRSingleRelationNew(item)"
                        >
                          Reprint
                        </v-btn>
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>

            <canvas ref="canvas" style="display: none"></canvas>

            <v-row justify="end">
              <v-col cols="auto">
                <!-- <v-btn :disabled="isPrintDisabled" @click="printQRAllRelations" color="error">
                  Print All
                </v-btn> -->
                <v-btn
                  :disabled="isPrintDisabled"
                  @click="printQRAllRelationsNew"
                  color="error"
                >
                  Print All
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- <a target="_blank" rel="noreferrer noopener" href="https://www.zebra.com/ap/en/support-downloads/printer-software/by-request-software.html#browser-print">
        Unduh Zebra Browser Print
      </a> -->
    </v-container>

    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>

    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </Main>
</template>

<style>
thead.v-data-table-header > tr > th > div {
  display: inline-block;
  width: 90%;
}

thead.v-data-table-header > tr > th > div.v-input label {
  font-size: 12px;
}

.reprint-button {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>

<script>
import Main from "@/Main.vue";
import QRCode from "qrcode";
import Handlebars from "handlebars";
import moment from "moment";
import PptxGenJS from "pptxgenjs";
import templatenew from "../../assets/template-qr.png";

import {
  getDefaultDevice,
  getLocalDevices,
  getPrinterStatus,
  print,
  ZPLTemplate,
} from "../../../lib/zebra";
import { log } from "handlebars/runtime";

const dtHeaders = [
  {
    text: "Branch",
    value: "BRANCH_CODE",
  },
  {
    text: "Position",
    value: "POSITION_CODE",
  },
  {
    text: "Type Salesman",
    value: "EMPLOYEE_TITLE_CODE",
  },
  {
    text: "Customer ID",
    value: "CUSTOMER_ID",
  },
  {
    text: "Customer Name",
    value: "CUSTOMER_NAME",
  },
  {
    text: "Is Print",
    value: "IsPrint",
  },
  {
    text: "Date Print",
    value: "LAST_UPDATE_PRINT",
  },
  {
    text: "Reprint",
    value: "ShouldReprint",
  },
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      isLoading: false,
      isShowSnackbar: false,
      isPrintDisabled: true,
      snackbarText: "",
      branchList: [],
      periodeList: [],
      positionList: [],
      yearList: [],
      branch: "ALL BRANCH",
      position: "",
      periode: "NONE",
      year: "NONE",
      searchRole: "",
      dtLoading: false,
      dtHeaders,
      dtItems: [],
      isSuperUser: JSON.parse(localStorage.getItem("userData")).ORG_ID == 81,
      printerNameList: [],
      printerList: [],
      selectedPrinterName: "",
      selectedPrinter: {},
      moment,
    };
  },
  async mounted() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    this.loadBranchList(userData.ORG_ID);

    try {
      const zebraDefaultPrinter = await getDefaultDevice();
      const otherZebraPrinters = await getLocalDevices();

      if (
        zebraDefaultPrinter.name !== undefined &&
        zebraDefaultPrinter.name !== null &&
        zebraDefaultPrinter.name !== ""
      ) {
        this.printerList.push(zebraDefaultPrinter);
        this.printerNameList.push(zebraDefaultPrinter.name);
      }

      for (let otherPrinter of otherZebraPrinters.printer) {
        if (!otherPrinter || otherPrinter.uid !== zebraDefaultPrinter.uid) {
          this.printerList.push(otherPrinter);
          this.printerNameList.push(otherPrinter.name);
        }
      }

      this.selectedPrinter = this.printerList[0];
      this.selectedPrinterName = this.printerNameList[0];
    } catch (error) {
      // this.showSnackbar('Printer tidak terdeteksi. Silakan jalankan Zebra Browser Print pada perangkat Anda');
    }
  },
  methods: {
    loadBranchList(orgID) {
      this.isLoading = true;
      this.$http
        .post(
          "/call-management/prepareFilter",
          { orgID: orgID },
          {
            headers: {
              "api-key": this.$apiKey,
            },
          }
        )
        .then((res) => {
          let { data } = res.data;

          if (orgID != 81) {
            this.branch = data.BRANCH_LIST[0].BRANCH_CODE;
          }

          this.branchList = data.BRANCH_LIST;
          this.periodeList = data.PERIODE;
          this.positionList = data.POSITION;
          this.yearList = data.YEAR;

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },

    async getRelasiPrintList() {
      if (this.branch === "" || this.position === "") {
        this.showSnackbar("Silakan pilih Position terlebih dulu");
        return;
      }

      this.dtLoading = true;
      this.isPrintDisabled = true;
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const res = await this.$http.get(
          `/mapping-sales-assignment/getRelasiPrint/${this.position}/${userData.ORG_ID}`,
          {
            headers: {
              "api-key": this.$apiKey,
            },
          }
        );

        let { data } = res.data;

        if (this.branch !== "ALL BRANCH") {
          data = data.filter((datum) => datum.BRANCH_CODE === this.branch);
        }

        this.dtItems = data.length > 0 ? data : [];

        // disable print button if first IsPrint > 0
        this.isPrintDisabled = data.length > 0 ? data[0].IsPrint > 0 : true;
      } catch (error) {
        this.showSnackbar(error.toString());
      }

      this.dtLoading = false;
    },

    async sendToPrinter(printer, labelTemplate, data) {
      try {
        const printerStatus = await getPrinterStatus(printer);
        const isReady = printerStatus.isPrinterReady();

        if (isReady) {
          // compile template with data
          const template = Handlebars.compile(labelTemplate);
          const rendered = template(data);

          // print compiled template
          await print(printer, rendered);
        }
      } catch (error) {
        throw error;
      }
    },

    // async printQRSingleRelation(relation) {
    //   try {
    //     const userData = JSON.parse(localStorage.getItem("userData"));

    //     const printPayload = {
    //       CUSTOMER_ID_REF: relation.CUSTOMER_ID,
    //       ORG_ID: relation.ORG_ID,
    //       ...relation,
    //     };

    //     this.dtLoading = true;
    //     this.showSnackbar(`Sedang mencetak QR untuk ${relation.CUSTOMER_NAME}`);

    //     await this.sendToPrinter(
    //       this.selectedPrinter,
    //       ZPLTemplate.Relation5x4AAMLogo,
    //       printPayload,
    //     );
    //   } catch (error) {
    //     this.showSnackbar(error.toString());
    //   }

    //   this.dtLoading = false;
    // },

    async printQRSingleRelationNew(relation) {
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));

        const printPayload = {
          CUSTOMER_ID_REF: relation.CUSTOMER_ID,
          ORG_ID: relation.ORG_ID,
          ...relation,
        };

        const newprintPayload = [printPayload];

        this.dtLoading = true;
        this.showSnackbar(`Sedang mencetak QR untuk ${relation.CUSTOMER_NAME}`);

        // console.log('printPayload', printPayload);

        await this.generateImageWithQR(newprintPayload);

        // await this.sendToPrinter(
        //   this.selectedPrinter,
        //   ZPLTemplate.Relation5x4AAMLogo,
        //   printPayload,
        // );
      } catch (error) {
        this.showSnackbar(error.toString());
      }

      this.dtLoading = false;
    },

    async generateImageWithQR(payloads) {
      const pptx = new PptxGenJS();
      pptx.defineLayout({ name: "Custom8x5", width: 8, height: 5.5 });
      pptx.layout = "Custom8x5";

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      try {
        // Preload template image
        const template = new Image();
        template.src = templatenew;
        await new Promise((resolve, reject) => {
          template.onload = resolve;
          template.onerror = () =>
            reject(new Error("Failed to load template image"));
        });

        // Set canvas size
        canvas.width = template.width;
        canvas.height = template.height;

        for (const payload of payloads) {
          try {
            // Clear canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Draw template on canvas
            ctx.drawImage(template, 0, 0);

            // Add text
            ctx.font = "bold 80px Arial";
            ctx.fillStyle = "Black";
            this.wrapText(ctx, payload.CUSTOMER_NAME_PRINT, 95, 800, 1000, 95, 4);

            ctx.font = "bold 80px Arial";
            ctx.fillStyle = "red";
            ctx.fillText(`${payload.BRANCH_CODE}`, 95, 1300);

            ctx.font = "60px Arial";
            ctx.fillStyle = "white";
            ctx.fillText(
              `Print Date: ${moment().format("MMM-YYYY")}`,
              1700,
              1485
            );

            // Generate QR Code
            const qrCodeDataUrl = await QRCode.toDataURL(
              `${payload.BRANCH_CODE};${payload.ORG_ID};${payload.CUSTOMER_ID};${payload.CUSTOMER_ID};${payload.CUSTOMER_NAME}`,
              { width: 200, margin: 0 }
            );

            const qrCode = new Image();
            qrCode.src = qrCodeDataUrl;
            await new Promise((resolve, reject) => {
              qrCode.onload = resolve;
              qrCode.onerror = () =>
                reject(new Error("Failed to load QR code image"));
            });

            ctx.drawImage(qrCode, 1500, 400, 980, 980);

            // Convert canvas to data URL
            const imageDataUrl = canvas.toDataURL();

            // Add slide to PPTX
            const slide = pptx.addSlide();
            slide.addImage({
              data: imageDataUrl,
              x: 0,
              y: 0,
              w: 8,
              h: 5.5,
            });
          } catch (slideError) {
            console.error(
              `Error processing payload for ${payload.CUSTOMER_NAME}:`,
              slideError
            );
          }
        }

        // Save PPTX file
        await pptx.writeFile(
          `StickerAAM_${payloads[0].BRANCH_CODE}_${payloads[0].POSITION_CODE}.pptx`
        );
      } catch (error) {
        console.error("Error generating PPTX file:", error);
      }
    },

    wrapText(ctx, text, x, y, maxWidth, lineHeight, maxLines) {
      const words = text.split(" ");
      let line = "";
      const lines = [];

      for (let i = 0; i < words.length; i++) {
        const testLine = line + words[i] + " ";
        const metrics = ctx.measureText(testLine);
        const testWidth = metrics.width;

        if (testWidth > maxWidth && i > 0) {
          lines.push(line.trim());
          line = words[i] + " ";
          if (lines.length === maxLines - 1) break;
        } else {
          line = testLine;
        }
      }

      if (line) lines.push(line.trim());

      for (let j = 0; j < lines.length; j++) {
        ctx.fillText(lines[j], x, y + j * lineHeight);
      }

      if (lines.length === maxLines) {
        ctx.fillText("...", x, y + (maxLines - 1) * lineHeight);
      }
    },

    async printQRAllRelationsNew() {
      if (this.dtItems.length <= 0) {
        return;
      }

      const userData = JSON.parse(localStorage.getItem("userData"));

      this.dtLoading = true;
      this.isPrintDisabled = true;

      this.showSnackbar("Sedang mencetak QR");

       let newData = this.dtItems.filter(k => k.IsPrint === 0)

      try {
        for (let relation of newData) {
        

          const payload = {
            customer_id: relation.CUSTOMER_ID,
            customer_name: relation.CUSTOMER_NAME,
            org_id: relation.ORG_ID,
            user_id: userData.USER_ID,
          };

          await this.$http.post(
            `/mapping-sales-assignment/markRelasiAsPrinted`,
            payload,
            {
              headers: {
                "api-key": this.$apiKey,
              },
            }
          );
        }
        // const printPayload = {
        //   CUSTOMER_ID_REF: relation.CUSTOMER_ID,
        //   ORG_ID: relation.ORG_ID,
        //   ...relation,
        // };
        await this.generateImageWithQR(newData);

        // await this.sendToPrinter(
        //   this.selectedPrinter,
        //   ZPLTemplate.Relation5x4AAMLogo,
        //   printPayload,
        // );
      } catch (error) {
        this.showSnackbar(error.toString());
      }

      // refetch marked relasi and stop loading
      this.getRelasiPrintList();
    },

    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
